import axios from "axios";
import helpers from "@/helpers.js";
import store from '../../store'
// import firebase from "firebase";

class AuditTrails {

    constructor() {
        this.filter_date = null ;
        this.filter_type = null ;
        this.filter_user_id = null ;
    }

    set_date(date){
        this.filter_date = date ;
    }

    set_type(type){
        this.filter_type = type ;
    }

    set_user_id(user_id){
        this.filter_user_id = user_id ;
    }

    get() {

        let params = "" ;

        params = params + "&company_id="+store.state.companies.currentCompany.id ;

        if(this.filter_date){
            params = params + "&filter_date="+this.filter_date ;
        }

        if(this.filter_user_id){
            params = params + "&filter_user_id="+this.filter_user_id ;
        }

        if(this.filter_type){
            params = params + "&filter_type="+this.filter_type ;
        }
        
        console.log('params '); 
        console.log(params); 

        
        store.commit("app/SET_LOADER", true) ;

        return helpers.get_token().then(function(idToken) {
            
            const config = {
                headers: { Authorization: "Bearer " + idToken }
            };
            
            return axios.get( 
                helpers.get_api_endpoint("/audit-trails", params),
                config
            ).then(function(response) {

                store.commit("app/SET_LOADER", false) ;

                return response.data ; 

            })
            .catch(error => {
                store.commit("app/SET_ERROR", error) ;
                return error ; 
            });

        }).catch(function(error) {

            store.commit("app/SET_ERROR", error) ;
            return error ; 
  
        });
        
    }

}

export default AuditTrails ;
